import { render, staticRenderFns } from "./ReportsComponent.vue?vue&type=template&id=bd4e3e26"
import script from "./ReportsComponent.vue?vue&type=script&lang=js"
export * from "./ReportsComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportsComponent.vue?vue&type=style&index=0&id=bd4e3e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports